import React, { useState, useRef } from "react";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useOutsideAlerter } from '../../../utils/CustomHooks';
import "../../../assets/styles/component/customer/itemDetail/SingleBannerPage.scss";
import { set_cart_items } from "../../../redux/actions/CartAction";
import { apiJson } from "../../../Api";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import CartSidebar from "../cart/CartSidebar";

function SingleItemPage(props) {
  const { images, data, language } = props;

  const sideCartRef = useRef(null);
  let message = "";
  const { t } = useTranslation();
  const [showCart, setShowCart] = useState(false);
  useOutsideAlerter(sideCartRef, setShowCart);
  const [checkout_redirect, setCheckoutRedirect] = useState(false);

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const extractOverview = (htmlText) => {
    if (!htmlText) return "Varathane Premium Fast Dry Wood Stain is an oil-based, durable wood stain that provides a fast-drying finish for interior wood surfaces. This stain penetrates deeply into the wood grain to provide long-lasting protection and rich, even color.";
    
    const text = htmlText.replace(/<[^>]*>?/gm, '');
    const sentences = text.match(/[^.!?]+[.!?]+/g) || [];
    const overview = sentences.slice(0, 5).join(' ').trim();
    
    return overview || "Varathane Premium Fast Dry Wood Stain is an oil-based, durable wood stain that provides a fast-drying finish for interior wood surfaces. This stain penetrates deeply into the wood grain to provide long-lasting protection and rich, even color.";
  };

  const getBannerData = () => {
    const title = data?.order_title || "Varathane Premium";
    const subtitle = data?.brand_name || "Fast Dry Wood Stain Cabernet";
    const description = extractOverview(data?.[`description_${language}`]);
    const image = images?.[0] || null;

    return {
      title: title,
      subtitle: subtitle,
      description: description,
      image: image
    };
  };

  const banner = getBannerData();

  const addToCartApiMethod = () => {
    // setAdding(true);
    apiJson.cart
      .addToCart(
        // props.data.product_type == "wholesale" ?
        //   {
        //     line_item: {
        //       quantity: parseInt(quantity.label ? quantity.label : quantity),
        //       orderable_type: "Variant",
        //       orderable_id: props.data.variantId,
        //       product_type: "wholesale"
        //     }
        //   }
        //   :
          // props.data.type === "Product"
          //   ? 
            {
              line_item: {
                quantity: 1,
                orderable_type: "Variant",
                orderable_id: props.data.order_id,
                is_assembly_added: false,
                // ...(addAssembly && { assembly_id: props.item.assembly.id })
              },
            }
            // : {
            //   line_item: {
            //     orderable_type: "Service",
            //     orderable_id: props.data.order_id,
            //     start_at: new Date(startDate).toString(),
            //     service_type: props.data?.service_type,
            //     ...(props.data?.service_type !== "one_time" && { end_at: new Date(endDate).toString() })
            //   },
            // },
        , props.countryId
      )
      .then((response) => {
        // setAdding(false);
        if (response.success) {
          if (
            localStorage.getItem("access_token") ||
            localStorage.getItem("user_key") === response.data.user_key
          ) {
            setShowCart(true);
          } else {
            localStorage.setItem("user_key", response.data.user_key);
            setShowCart(true);
          }
        } else if (!response.status) {
          message = t("errors.wrong");
          showError();
        } else {
          if (response.status >= 400 && response.status < 500) {
            message = response.message
              ? response.message
              : response.errors
                ? response.errors
                : t("errors.wrong");
            showError();
          } else {
            message = response.message
              ? response.message !== ""
                ? response.message
                : t("errors.wrong")
              : t("errors.wrong");
            showError();
          }
        }
      });
  }

  const buyNowApiMethod = () => {
    apiJson.cart
      .addToCart(
        // props.product?.product_type == "wholesale" ?
        //   {
        //     line_item: {
        //       quantity: parseInt(quantity.label ? quantity.label : quantity),
        //       orderable_type: "Variant",
        //       orderable_id: variant.id,
        //       product_type: "wholesale"
        //     }
        //   }
        //   :
        //   props.product?.type === "Product"
        //     ? 
            {
              line_item: {
                // quantity: parseInt(quantity.label ? quantity.label : quantity),
                quantity: 1,
                orderable_type: "Variant",
                orderable_id: props.data.order_id,
              },
            }
            // : {
            //   line_item: {
            //     orderable_type: "Service",
            //     orderable_id: props.product?.id,
            //     start_at: new Date(startDate).toString(),
            //     end_at: new Date(endDate).toString(),
            //   },
            // },
        , props.countryId
      )
      .then((response) => {
        if (response.success) {
          if (
            localStorage.getItem("access_token") ||
            localStorage.getItem("user_key") === response.data.user_key
          ) {
            // setShowCart(true);
          } else {
            localStorage.setItem("user_key", response.data.user_key);
            // setShowCart(true);
          }

          props.set_cart_items({ cart_items: response.data })

          // move to checkout
          if (props.auth) {
            apiJson
              .select.getDefault()
              .then(resp => {
                if (resp.success) {
                  if (resp.data.length > 0) {
                    const request = {
                      order: {
                        address_id: resp.data[0].id,
                        is_delivery: 1
                      },
                    };

                    apiJson.select
                      .varifyAdress(request, props.countryId)
                      .then((response) => {
                        if (response.success) {
                          props.set_cart_items({
                            order: {
                              address: resp.data[0],
                              id: response.data.id,
                              createdAddress: response.data,
                            },
                          });
                          setCheckoutRedirect({
                            value: true,
                            path:
                              "/" + props.countryUrl + "-" + props.language + "/checkout",
                          });
                        } else if (!response.status) {
                          message = t("errors.wrong");
                          showError();
                        } else {
                          if (response.status >= 400 && response.status < 500) {
                            message = response.message
                              ? response.message
                              : response.errors
                                ? response.errors
                                : t("errors.wrong");
                            showError();
                          } else {
                            message = response.message
                              ? response.message !== ""
                                ? response.message
                                : t("errors.wrong")
                              : t("errors.wrong");
                            showError();
                          }
                        }
                      });
                  }
                  else {
                    props.set_cart_items({
                      order: {
                        address: null,
                        id: null,
                        createdAddress: null,
                      },
                    });
                    setCheckoutRedirect({
                      value: true,
                      path:
                        "/" + props.countryUrl + "-" + props.language + "/checkout",
                    });
                  }
                }
              });
          }
          else {
            props.set_cart_items({
              order: {
                address: null,
                id: null,
                createdAddress: null,
              },
            });
            setCheckoutRedirect({
              value: true,
              path:
                "/" + props.countryUrl + "-" + props.language + "/checkout",
            });
          }
          // move to checkout end

        } else if (!response.status) {
          message = t("errors.wrong");
          showError();
        } else {
          if (response.status >= 400 && response.status < 500) {
            message = response.message
              ? response.message
              : response.errors
                ? response.errors
                : t("errors.wrong");
            showError();
          } else {
            message = response.message
              ? response.message !== ""
                ? response.message
                : t("errors.wrong")
              : t("errors.wrong");
            showError();
          }
        }
      });
  }

  return (
    <div className="single-item-page-wrapper">
      <div className="single-banner-container">
        {banner.image && (
          <div className="single-banner-image-container">
            <div className="image-aspect-ratio-wrapper">
              <img
                src={banner.image.img || banner.image}
                alt="Product"
                className="single-banner-image"
                onError={(e) => {
                  e.target.onerror = null; 
                  e.target.src = "/path/to/default-image.jpg";
                }}
              />
            </div>
          </div>
        )}
        <div className="single-banner-content">
          <h1 className="single-banner-title">{banner.title}</h1>
          <p className="single-banner-description">{banner.description}</p>
          <div className="single-banner-buttons">
            <button
            className="view-more-button"
            onClick={addToCartApiMethod}
            >Add to Cart</button>
             <button
             className="buy-now-button"
             onClick={buyNowApiMethod}
             >Buy Now</button>
          </div>
        </div>
      </div>
      {showCart && <CartSidebar refs={sideCartRef} bool={showCart} />}
      {checkout_redirect.value && (
        <Redirect
          push
          to={{
            pathname: checkout_redirect.path,
            state: checkout_redirect.state,
          }}
        />
      )}
    </div>
  );
}

SingleItemPage.propTypes = {
  images: PropTypes.array,
  data: PropTypes.object,
  language: PropTypes.string
};

const mapStateToProps = (state) => ({
  language: state.language.language,
  countryUrl: state.language.countryUrl,
  auth: state.auth.isSignedIn,
  countryId: state.language.countryId,
});

const mapDispatchToProps = { set_cart_items };

export default connect(mapStateToProps, mapDispatchToProps)(SingleItemPage);